var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main"},[_c('el-container',{attrs:{"direction":"vertical"}},[_c('navbar'),_c('el-container',{staticClass:"live-container"},[(!_vm.$store.state.isInfor)?_c('sidebar'):_vm._e(),_c('el-main',{attrs:{"id":"scrollContainer"}},[_c('div',{staticClass:"app-container"},[_c('app-main')],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }